import React, {useState} from 'react';
import '../ThankYouPage/Styles.css';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import useTitle from '../../useTitle';
import ContactSection from '../ContactSection/Index';

const ThankYou = () => {
    useTitle("Bedankt! Je bericht is goed ontvangen");
    // eslint-disable-next-line no-unused-vars
    const [isOpen, setIsOpen] = useState(false);
    // Close the navbar when a link is clicked
    const handleLinkClick = (url) => {
        setIsOpen(false); // Close the navbar
        window.location.href = url; // Force navigation to the specific URL
    };
  return (
    <>
      <div className='thankYouPageContainer'>
        <div className='thankYouTitleContainer'>
            <h1 className='bedanktTitel'>Bedankt voor je bericht!</h1>
        </div>

        <div className='thankYouDescriptionContainer'>
            <p>Je bericht is goed ontvangen door Mindful Breaks. <br/> Ik neem zo snel mogelijk persoonlijk contact met je op om je vraag of bericht te beantwoorden.</p>
            <br />
            <p>Heb je in de tussentijd nog iets toe te voegen of is er iets dringends? <br /> Voel je vrij om me te mailen of even te bellen.</p>
        </div>

        <div className='homePaginaButtonContainer'>
            <Link onClick={() => handleLinkClick('/')}  className='terugNaarHomePaginaButton'>Ga terug naar de Homepagina</Link>
        </div>
      </div>

       {/* Contact/Menu Section */}
        <ContactSection />
    </>
  )
}

export default ThankYou;